angular.module("faqAccordion.components", ["app.services"]).component("faqAccordion", {
  templateUrl: "ng/components/faqAccordion/faqAccordion.view.html",
  /**
   * This accordion id is going to be:
   * #faq-accordion-<category>-id
   */
  bindings: {
    mapAppFaq: "<",
    onClickCallback: "&",
    id: "="
  },
  controllerAs: "FaqAccordionCtrl",
  controller: function () {
    var self = this;

    self.$onInit = function () {
      retrieveMapAppFaqElements(self.mapAppFaq);
    };

    self.$onChanges = function (changes) {
      retrieveMapAppFaqElements(self.mapAppFaq);
    }

    var retrieveMapAppFaqElements = function (mapAppFaqResponse) {
      self.mapAppFaqValues = mapAppFaqResponse;
    }
  }
});